import { useEffect, useState } from 'react';
import { getRotationHandlePosition, getSelectionClientMetrics } from './rotationHandleUtils';
import './RotationHandle.css';

function RotationHandle({ json, selectedIds, mode, readonly, isRotating, onPointerDown }) {
    const [position, setPosition] = useState(null);
    const shouldShow = mode === 'transform' && !readonly && selectedIds?.some(id => json?.[id]?.box);

    useEffect(() => {
        if (!shouldShow) {
            setPosition(null);
            return;
        }

        let animationFrame = null;

        const updatePosition = () => {
            const metrics = getSelectionClientMetrics(json, selectedIds);
            const nextPosition = getRotationHandlePosition(metrics);

            setPosition(prev => {
                if (!prev && !nextPosition) return prev;
                if (!prev || !nextPosition) return nextPosition;

                const samePosition =
                    Math.abs(prev.x - nextPosition.x) < 0.5 &&
                    Math.abs(prev.y - nextPosition.y) < 0.5;

                return samePosition ? prev : nextPosition;
            });

            animationFrame = window.requestAnimationFrame(updatePosition);
        };

        updatePosition();

        return () => {
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
        };
    }, [json, selectedIds, shouldShow]);

    if (!shouldShow || !position) return null;

    return (
        <button
            aria-label="Girar selecció"
            className={`rotation-handle${isRotating ? ' rotating' : ''}`}
            onPointerDown={onPointerDown}
            style={{
                left: position.x,
                top: position.y
            }}
            title="Girar selecció (snap de 5°)"
            type="button"
        />
    );
}

export default RotationHandle;
